import type { Messages } from './messages';

/**
 * The shell's words: the toolbar, the workspace's sub toolbar, the route-level frames
 * (404, forbidden, boot). Owned by lib; `lib/nav.ts` is the only reader of the
 * `nav.*` and `tab.*` labels and every destination is named here once.
 */
export const nav = {
  'nav.appName': 'لوحة المنصّة',
  /* The operator company. The panel is تحوّل's; أيد is one المنشأة among many. */
  'nav.brand': 'تحوّل',
  'nav.sections': 'أقسام اللوحة',
  'nav.account': 'قائمة الحساب',
  'nav.signOut': 'تسجيل الخروج',
  'nav.menu': 'القائمة',
  'nav.toLight': 'التبديل إلى الوضع الفاتح',
  'nav.toDark': 'التبديل إلى الوضع الداكن',

  'nav.dashboard': 'الرئيسية',
  'nav.tenants': 'المنشآت',
  'nav.permissions': 'الصلاحيات',
  'nav.models': 'النماذج',
  'nav.audit': 'سجل التدقيق',
  'nav.defaults': 'الإعدادات الافتراضية',
  'nav.gallery': 'معرض المكوّنات',

  'tab.overview': 'نظرة عامة',
  'tab.content': 'المحتوى',
  'tab.members': 'الأعضاء',
  'tab.roles': 'الأدوار والصلاحيات',
  'tab.mail': 'البريد',
  'tab.microsoft': 'الدخول عبر Microsoft',
  'tab.models': 'النماذج',
  'tab.audit': 'التدقيق',

  'frame.notFoundTitle': 'الصفحة غير موجودة',
  'frame.notFoundBody': 'العنوان الذي فتحته لا يقابل أي صفحة في اللوحة.',
  'frame.notFoundHome': 'العودة إلى الرئيسية',
  'frame.forbiddenTitle': 'لا تملك صلاحية هذه الصفحة',
  'frame.forbiddenBody': 'رتبتك لا تحمل الصلاحية التي تتطلبها: {permission}.',
  'frame.errorTitle': 'تعذّر عرض هذه الصفحة',
  'frame.chunkTitle': 'صدر إصدار أحدث من اللوحة',

  /* The sign-in brand panel (brief §2.1). The form itself is the page author's. */
  'frame.authHeadline': 'لوحة المنصّة — إدارة المنشآت لا محتواها',
  'frame.authLead':
    'من هنا تُنشأ المنشآت وتُدار حساباتها وأدوارها وبريدها ونماذجها، ويُقرأ ما أنفقته. محتواها نفسه غير مقروء من هنا بحكم العزل.',
  'frame.authPointTenants': 'إنشاء المنشآت وإدارة حساباتها وأدوارها',
  'frame.authPointBoundary': 'أعداد وبيانات إدارية فقط — لا محادثات ولا مستندات',
  'frame.authPointAudit': 'كل إجراء يُسجَّل في سجل تدقيق المنصّة',
  'frame.authFootnote': 'تحوّل · للمشغّلين المخوَّلين فقط',
  'frame.booting': 'جارٍ التحقق من الجلسة…',
  'frame.bootFailed': 'تعذّر التحقق من جلستك.',
  'frame.placeholder': 'TODO(page-author): هذه الصفحة هيكل فقط.',
} as const satisfies Messages<'nav' | 'tab' | 'frame'>;
